<div class="row border">
	<div class="col-md-12 text-center">
		<h4 style="padding: 1em; font-weight: bold;">Remove Hard Drives</h4>
	</div>
</div>

<br>

<div class="row">
    <div class="col-md-12 border">
    	<dinamic-table
            *ngIf="!loading"
            [id]="'removeHardDrivesTable'"
            [data]="multipleData"
            [bulk]="bulk"
            [cleanbulk]="true"
            [checkAllGrayed]="true"
            (changeBulk)="checkBulk($event)"
        ></dinamic-table>
    </div>
</div>

<div class="row" style="margin-top: 10px;">
	<div class="class md-12">
		<button type="button" class="btn btn-danger btn-md" (click)="close()">
          Close
    </button>
    &nbsp; &nbsp;
    <button (click)="openModalRemove()" class="btn btn-danger btn-md" [disabled]="this.bulk.length === 0">
      <i class="fa fa-times" aria-hidden="true"></i> &nbsp; Remove Hard Drives ({{ bulk.length }})
    </button>
    &nbsp; &nbsp;
    <button (click)="openModalReturn()" class="btn btn-warning btn-md" [disabled]="this.bulk.length === 0" *ngIf="statusRemoveHardDrive === 'REMOVED'">
      <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Return Hard Drives ({{ bulk.length }})
    </button>
	</div>
</div>

<div class="modal fade" id="modalRemove" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalScrollableTitle">Save Changes</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>Are these drives going to be destroyed?</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="removeHardDrives(1)">Yes</button>
            &nbsp; &nbsp;
            <button type="button" class="btn btn-danger" (click)="removeHardDrives(0)">No</button>
          </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPartial" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalScrollableTitle">Save Changes</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>This drive needs to be physically destroyed!</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="removeHardDrives(1)">Accept</button>
          </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalReturn" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalScrollableTitle">Return Status</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>Are you sure you want to return these drives back to the device?</strong>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="returnStatus()">Yes</button>
            &nbsp; &nbsp;
            <button type="button" class="btn btn-danger" data-dismiss="modal">No</button>
          </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalCheckReport" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalScrollableTitle">Physical Destruction Report</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              <strong>Choose the report</strong>
            </p>
          </div>
          <div class="modal-footer">
            <!--<button type="button" class="btn btn-success" (click)="checkReport('basic')">Basic</button>
            &nbsp; &nbsp;
            <button type="button" class="btn btn-success" (click)="checkReport('detail')">Detailed</button>-->
          </div>
        </div>
    </div>
</div>